export enum Alignment {
  STARTING = 'STARTING',
  CENTER = 'CENTER',
}

export default null;
